import {Button, Col, Row, Space, Typography, Radio, Input, Form} from "antd";
import React, {useEffect, useState} from "react";
import Icons from "assets/icons";
import {DataInputField, InputFields} from "components/common";
import "./AppendAgesExpand.scss";
import Icon from "@ant-design/icons";
import {
  FieldsAppendAgesRight,
  fieldsEyelidsRight,
  fieldsEyelashesRight,
  fieldsLacrimalRight,
  fieldsSyryingRight,
  FieldsAppendAgesLeft,
  fieldsEyelidsLeft,
  fieldsEyelashesLeft,
  fieldsLacrimalLeft,
  fieldsSyryingLeft,
  fieldsCommentLeft,
  fieldsCommentRight,
} from "./AppendAgesExpand.config";
import {useAppSelector} from "redux/hooks";

type Props = {
  isOpen: boolean;
  setIsOpen: () => void;
  index: number;
};

const AppendAgesExpand: React.FC<Props> = ({isOpen, setIsOpen, index}) => {
  const objectChanDoan = useAppSelector(
    state => state.examination.objectChanDoan
  );
  const ref = useAppSelector(state => state.examination.ref);

  const dataChanDoan = useAppSelector(state => state.examination.dataChanDoan);
  const examRef = useAppSelector(state => state.examination.ref);
  const [eyeLid, setEyeLid] = useState<boolean>(false);
  const [eyeLashes, setEyeLashes] = useState<boolean>(false);
  const [lacrimal, setLacrimal] = useState<boolean>(false);
  const [syrying, setSyrying] = useState<boolean>(false);
  const [data, setData] = useState(null);
  useEffect(() => {
    if (examRef) {
      examRef.setFieldValue(["leftJsonValue", "APPENDAGES", "Option"], []);
      examRef.setFieldValue(["rightJsonValue", "APPENDAGES", "Option"], []);
    }
  }, [examRef]);
  useEffect(() => {
    if (dataChanDoan) {
      const formValue = JSON.parse(dataChanDoan?.jsonValue);
      if (index == 0) {
        setData(formValue?.rightJsonValue?.APPENDAGES);
      }
      if (index == 1) {
        setData(formValue?.leftJsonValue?.APPENDAGES);
      }
    }
  }, [dataChanDoan]);
  useEffect(() => {
    if (!isOpen) {
      // const fieldsValue = ref.getChanDoanValue();
      if (ref) {
        ref.setFieldValue(
          [`${index == 1 ? "leftJsonValue" : "rightJsonValue"}`, "APPENDAGES"],
          null
        );
      }
    }
    if (ref) {
      ref.setFieldValue(
        [
          `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
          "APPENDAGES",
          "show",
        ],
        isOpen
      );
    }
  }, [isOpen, ref]);
  useEffect(() => {
    if (objectChanDoan && ref) {
      const show = ref.getFieldValue([
        `${index == 1 ? "leftJsonValue" : "rightJsonValue"}`,
        "APPENDAGES",
        "show",
      ]);
      if (Boolean(show) == true && isOpen == false) {
        setIsOpen();
      }
      if (Boolean(show) == false && isOpen == true) {
        setIsOpen();
      }
    }
  }, [objectChanDoan, ref]);
  useEffect(() => {
    if (data) {
      
      // const showEyeLid = checkValueOfObject(data["Mi mắt"], true);
      // const showEysLashes = checkValueOfObject(data["Lông mi"], true);
      // const showLacrimal = checkValueOfObject(data["Túi lệ"], true);
      // const showSyrying = checkValueOfObject(data["Thăm dò lệ đạo"], "Tắc");
      const showEyeLid = data["Mi mắt"];
      const showEysLashes = data["Lông mi"];
      const showLacrimal = data["Túi lệ"];
      const showSyrying = data["Thăm dò lệ đạo"];
      setEyeLid(showEyeLid);
      setEyeLashes(showEysLashes);
      setLacrimal(showLacrimal);
      setSyrying(showSyrying);

      let newOptions = [];
      if (showEyeLid) {
        newOptions.push("Mi mắt");
      }
      if (showEysLashes) {
        newOptions.push("Lông mi");
      }
      if (showLacrimal) {
        newOptions.push("Túi lệ");
      }
      if (showSyrying) {
        newOptions.push("Thăm dò lệ đạo");
      }
      examRef.setFieldValue(
        [
          `${index == 0 ? "rightJsonValue" : "leftJsonValue"}`,
          "APPENDAGES",
          "Option",
        ],
        newOptions
      );
    }
  }, [data]);
  const checkValueOfObject = (obj, value) => {
    if (obj) {
      return Object.values(obj).findIndex(e => e == value) != -1;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (index == 0) {
      FieldsAppendAgesRight[0].onChange = e => {
        setEyeLid(e?.includes("Mi mắt"));
        setEyeLashes(e?.includes("Lông mi"));
        setLacrimal(e?.includes("Túi lệ"));
        setSyrying(e?.includes("Thăm dò lệ đạo"));
      };
    }
    if (index == 1) {
      FieldsAppendAgesLeft[0].onChange = e => {
        setEyeLid(e?.includes("Mi mắt"));
        setEyeLashes(e?.includes("Lông mi"));
        setLacrimal(e?.includes("Túi lệ"));
        setSyrying(e?.includes("Thăm dò lệ đạo"));
      };
    }
  }, []);
  return (
    <Space
      direction="vertical"
      className="space-common space-appendAges"
      size={"middle"}
    >
      <Row justify={"start"} className="row-common">
        <Button
          type="primary"
          icon={isOpen ? <Icons.sub rev={0} /> : <Icons.add rev={0} />}
          onClick={setIsOpen}
        />
        <Typography className="title-common-healthy">PHẦN PHỤ</Typography>
      </Row>

      {isOpen ? (
        <div>
          <Row gutter={[16, 8]}>
            <InputFields
              data={index === 0 ? FieldsAppendAgesRight : FieldsAppendAgesLeft}
            />
            {eyeLid && (
              <InputFields
                data={index == 0 ? fieldsEyelidsRight : fieldsEyelidsLeft}
              ></InputFields>
            )}
            {eyeLashes && (
              <InputFields
                data={index == 0 ? fieldsEyelashesRight : fieldsEyelashesLeft}
              ></InputFields>
            )}
            {lacrimal && (
              <InputFields
                data={index == 0 ? fieldsLacrimalRight : fieldsLacrimalLeft}
              ></InputFields>
            )}
            {syrying && (
              <InputFields
                data={index == 0 ? fieldsSyryingRight : fieldsSyryingLeft}
              ></InputFields>
            )}
            <InputFields
              data={index == 0 ? fieldsCommentRight : fieldsCommentLeft}
            ></InputFields>
          </Row>
        </div>
      ) : null}
    </Space>
  );
};

export default AppendAgesExpand;
